export const payoutRequestGrantSimpleLocalization = {
  headerTitle: {
    nb: 'Utbetaling av tilskudd',
    nn: 'Utbetaling av tilskot',
    en: 'Payout request grant',
  },
  earlierDeMinimisAidLabel: {
    nb: 'Tidligere bagatellmessig støtte',
    nn: 'Tidlegare bagatellmessig støtte',
    en: 'Previous De Minimis Aid',
  },
  payoutAmountLabel: {
    nb: 'Totalt tildelt støttebeløp i NOK',
    nn: 'Totalt tildelt støttebeløp i NOK',
    en: 'Total Awarded Aid Amount in NOK',
  },
  payoutAmountError: {
    nb: 'Du må oppgi et beløp som er lavere eller lik det tilgjengelige beløpet',
    nn: 'Du må oppgi et beløp som er lavere eller lik det tilgjengelige beløpet',
    en: 'You must enter an amount lower or equal to the available amount',
  },
  payoutAmountDigitsOnly: {
    nb: 'Kun hele tall er tillatt',
    nn: 'Berre heiltal er tillatne',
    en: 'Only digits are allowed',
  },
  titlePage1: {
    nb: 'Før du begynner',
    nn: 'Før du begynner',
    en: 'Before you start',
  },
  descriptionPage1: {
    nb: 'Aktiviteten som tilskuddet gjelder må være gjennomført før du kan søke om utbetaling.',
    nn: 'Aktiviteten som tilskotet gjeld må vere gjennomført før du kan søkje om utbetaling.',
    en: '',
  },
  infoBoxHeading: {
    nb: 'Du må fylle ut og sende inn både søknad om utbetaling og sluttrapport',
    nn: 'Du må fylle ut og sende inn både søknad om utbetaling og sluttrapport',
    en: 'You must complete and submit both the payout request and the final report',
  },
  infoBoxListItem1: {
    nb: 'Søknaden om utbetaling inneholder utbetalingsdetaljer og dokumentasjon.',
    nn: 'Søknaden om utbetaling inneheld utbetalingsdetaljar og dokumentasjon.',
    en: 'The payout request contains payout details and documentation.',
  },
  infoBoxListItem2: {
    nb: 'Sluttrapporten skal beskrive gjennomførte aktiviteter, resultater og veien videre.',
    nn: 'Sluttrapporten skal beskrive gjennomførte aktivitetar, resultat og vegen vidare.',
    en: 'The final report shall describe the activities carried out, the results and the way forward.',
  },
  finalReportReminder: {
    nb: 'Husk at både søknad om utbetaling og sluttrapport må sendes inn før saken kan behandles ferdig og tilskudd utbetales.',
    nn: 'Hugs at både søknad om utbetaling og sluttrapport må sendast inn før saka kan behandlast ferdig og tilskot utbetalast.',
    en: 'Please note that both the application for disbursement and the final report must be submitted before the case can be fully processed and the grant disbursed.',
  },
  payoutLetterParagraph: {
    nb: 'For raskest mulig saksbehandling er det viktig at du setter deg inn i vilkårene for tilskuddet. Dette finner du i tilbudsbrevet nedenfor.',
    nn: 'For raskast mogleg saksbehandling er det viktig at du set deg inn i vilkåra for tilskotet. Dette finn du i tilbodsbrevet nedanfor.',
    en: 'For the fastest possible processing of your case, it is important that you familiarize yourself with the conditions for the grant. You can find these in the offer letter below.',
  },
  customerDetails: {
    nb: 'Innhentet informasjon',
    nn: 'Innhenta informasjon',
    en: 'Customer details',
  },
  customerDetailsCustomer: {
    nb: 'Kunde',
    nn: 'Kunde',
    en: 'Customer',
  },
  customerDetailsReference: {
    nb: 'Referanse',
    nn: 'Referanse',
    en: 'Reference',
  },
  customerDetailsInstrument: {
    nb: 'Virkemiddel',
    nn: 'Verkemiddel',
    en: 'Instrument',
  },
  customerDetailsAccount: {
    nb: 'Konto',
    nn: 'Konto',
    en: 'Account',
  },
  customerDetailsApprovedDate: {
    nb: 'Innvilget dato',
    nn: 'Innvilga dato',
    en: 'Approved date',
  },
  customerDetailsAvailableAmount: {
    nb: 'Tilgjengelig beløp',
    nn: 'Tilgjengeleg beløp',
    en: 'Available amount',
  },
  projectCompletedTitle: {
    nb: 'Har du gjennomført aktiviteten som tilskuddet gjelder?',
    nn: 'Har du gjennomført aktiviteten som tilskotet gjeld?',
    en: 'Has the activity associated with the grant been completed?',
  },
  projectCompletedYes: {
    nb: 'Ja',
    nn: 'Ja',
    en: 'Yes',
  },
  projectCompletedNo: {
    nb: 'Nei, aktiviteten er ikke gjennomført',
    nn: 'Nei, aktiviteten er ikke gjennomført',
    en: 'No, the activity has not been completed',
  },
  projectCompletedErrorLabel: {
    nb: 'Aktiviteten må være gjennomført før du kan be om utbetaling.',
    nn: 'Aktiviteten må være gjennomført før du kan be om utbetaling.',
    en: 'The activity must be completed before you can request payout.',
  },
  titlePage2: {
    nb: 'Utbetaling og dokumentasjon',
    nn: 'Utbetaling og dokumentasjon',
    en: 'Payment and documentation',
  },
  payoutHeading: {
    nb: 'Utbetaling',
    nn: 'Utbetaling',
    en: 'Payout',
  },
  payoutDescription: {
    nb: 'Alle beløp er oppgitt i norske kroner (NOK).',
    nn: 'Alle beløp er oppgitte i norske kroner (NOK).',
    en: 'All amounts are stated in Norwegian kroner (NOK).',
  },
  payoutAvailableAmount: {
    nb: 'Tilgjengelig beløp',
    nn: 'Tilgjengeleg beløp',
    en: 'Available amount',
  },
  payoutAmount: {
    nb: 'Utbetalingsbeløp',
    nn: 'Utbetalingsbeløp',
    en: 'Payout amount',
  },
  payoutRemainingAmount: {
    nb: 'Gjenstående beløp (annulleres)',
    nn: 'Attverande beløp (annullerast)',
    en: 'Remaining amount (to be cancelled)',
  },
  payoutBankAccountNumberLabel: {
    nb: 'Kontonummer for utbetaling',
    nn: 'Kontonummer for utbetaling',
    en: 'Account number for payment',
  },
  payoutBankAccountNumberDescription: {
    nb: 'Kontonummer må tilhøre støttemottaker',
    nn: 'Kontonummer må tilhøre støttemottaker',
    en: 'The account number must belong to the beneficiary',
  },
  payoutBankAccountNumberError: {
    nb: 'Du må oppgi et gyldig kontonummer for utbetaling',
    nn: 'Du må oppgi et gyldig kontonummer for utbetaling',
    en: 'The payout account number must be valid',
  },
  payoutBankAccountNumberDigitsOnly: {
    nb: 'Kun tall er tillat',
    nn: 'Berre tal er tillatne',
    en: 'Only digits are allowed',
  },
  documentationHeading: {
    nb: 'Dokumentasjon',
    nn: 'Dokumentasjon',
    en: 'Documentation',
  },
  documentationDescription: {
    nb: 'Forsikre deg om at du har forstått hvilke kostnader som dekkes før du laster opp faktura eller betalingsbilag. Dette finner du i tilbudsbrevet.',
    nn: 'Forsikre deg om at du har forstått kva kostnader som blir dekka før du lastar opp faktura eller betalingsbilag. Dette finn du i tilbodsbrevet.',
    en: 'Make sure that you have understood which costs are covered before you upload the invoice or payment documentation. You can find this information in the offer letter.',
  },
  documentationError: {
    nb: 'Du må laste opp faktura eller betalingsbilag',
    nn: 'Du må laste opp faktura eller betalingsbilag',
    en: 'You must upload an invoice or a payment voucher',
  },
  documentationUploadLabel: {
    nb: 'Last opp faktura eller betalingsbilag (maks 3 filer)',
    nn: 'Last opp faktura eller betalingsbilag (maks 3 filer)',
    en: 'Upload invoice or payment voucher (maximum 3 files)',
  },
  documentationUploadDescription: {
    nb: 'Du kan laste opp følgende filtyper: .pdf, .docx, .xlsx, .odt og .ods',
    nn: 'Du kan laste opp følgjande filtypar: .pdf, .docx, .xlsx, .odt og .ods',
    en: 'You can upload the following file types: .pdf, .docx, .xlsx, .odt, and .ods',
  },
  delete: {
    nb: 'Slett',
    nn: 'Slett',
    en: 'Delete',
  },
  summaryTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  finalCheckHeading: {
    nb: 'Sjekk at alt stemmer',
    nn: 'Sjekk at alt stemmer',
    en: 'Make sure that everything is correct',
  },
  finalCheckBody: {
    nb: 'Feil eller mangler i søknaden vil føre til lengre behandlingstid og forsinket utbetaling.',
    nn: 'Feil eller manglar i søknaden vil føre til lengre behandlingstid og forseinka utbetaling.',
    en: 'Errors or deficiencies in the application will result in longer processing times and delayed payment.',
  },
  termsAndConditionsTitle: {
    nb: 'Betingelser og vilkår',
    nn: 'Vilkår og føresetnadar',
    en: 'Terms and Conditions',
  },
  termsAndConditionsPart1: {
    nb: 'Aktiviteten som tilskuddet gjelder må være gjennomført før du kan be om utbetaling',
    nn: 'Aktiviteten som tilskotet gjeld, må vere gjennomført før du kan be om utbetaling',
    en: 'The activity for which the grant applies must be completed before you can request a payment',
  },
  termsAndConditionsPart2: {
    nb: 'Oppgitt kontonummer for utbetaling må tilhøre støttemottaker',
    nn: 'Oppgitt kontonummer for utbetaling må høyre til støttemottakaren',
    en: 'The specified account number for payment must belong to the beneficiary',
  },
  termsAndConditionsPart3: {
    nb: 'Vedlagte faktura eller betalingsbilag er kun forbundet med kostnader som er godkjent i tilbudsbrevet',
    nn: 'Vedlagde faktura eller betalingsbilag er berre knytt til kostnader som er godkjende i tilbodsbrevet',
    en: 'The attached invoice or payment document is only associated with costs that have been approved in the offer letter.',
  },
  confirmBeforeSubmission: {
    nb: 'Bekreft før innsending',
    nn: 'Stadfest før innsending',
    en: 'Confirm before submission',
  },
  confirmBeforeSubmissionCheckbox1: {
    nb: 'Jeg bekrefter at disse opplysningene stemmer',
    nn: 'Eg stadfestar at desse opplysningane er riktige',
    en: 'I confirm that this information is correct',
  },
  confirmBeforeSubmissionCheckbox2: {
    nb: 'Jeg bekrefter at jeg har lest og er kjent med Innovasjon Norges betingelser og vilkår for tildeling av bagatellmessig støtte',
    nn: 'Eg stadfestar at eg har lese og er kjent med Innovasjon Noreg sine vilkår og betingingar for tildeling av bagatellmessig støtte',
    en: 'I confirm that I have read and am familiar with Innovation Norway’s terms and conditions for granting de minimis aid',
  },
  confirmBeforeSubmissionCheckbox3: {
    nb: 'Jeg bekrefter at partneres erklæringer er vedlagt denne erklæringen',
    nn: 'Eg stadfestar at partnarane sine fråsegner er vedlagt denne fråsegna',
    en: 'I confirm that the partners’ declarations are attached to this declaration',
  },
  payoutAmountRequired: {
    nb: 'Du må oppgi utbetalingsbeløp',
    nn: 'Du må oppgi utbetalingsbeløp',
    en: 'Please specify the payout amount',
  },
} as const;
